<template>
  <div>
    <div :class="view_class_view.div_container.container">
          <div>
              <label :class="view_class_view.div_container.label" for="select_marital_status"> Estado civil: </label>
              <select name="select_marital_status" id="select_marital_status"
                  v-model="maritalStatusModel.status"
                  v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]:  _maritalStatus$.status.$error,
                          [view_class_view.input_class.default + view_class_view.input_class.valid]:! _maritalStatus$.status.$invalid,
                          [view_class_view.input_class.default ]:  _maritalStatus$.status.$invalid && ! _maritalStatus$.status.$error  }"
                  @blur="_maritalStatus$.status.$validate"
                  @change="on_change_civil_status()">
                  <option selected disabled value="">Seleccione un estado civil</option>
                  <option value="Soltero(a)">Soltero(a)</option>
                  <option value="Casado(a)">Casado(a)</option>
                  <option value="Divorciado(a)">Divorciado(a)</option>
                  <option value="Viudo(a)">Viudo(a)</option>
                  <option value="Concubinato">Concubinato</option>
              </select>

              <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _maritalStatus$.status.$errors" :key="index">
                  <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
              </div>
          </div>

          <div v-show="displayInputs.status && maritalStatusModel.status.toString().toUpperCase() != 'CONCUBINATO'">
              <ChooseButton
                ref="RefChooseButtonRegimeOfGoods"
                  :buttons="buttonsRegimeOfGoods"
                  :flex="true"
                  v-model="maritalStatusModel.regimeOfGoods"
                  v-on:choose-button="get_value_choose_button_regime($event)"
                  label="Régimen de Bienes:"
                  :buttons_styles="buttons_styles" 
              />

              <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _maritalStatus$.regimeOfGoods.$errors" :key="index">
                  <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
              </div>
          </div>
          
        <!-- RFC -->
        <div v-show="displayInputs.rfc">
          <label
          :class="view_class_view.div_container.label"
            for="input_RFC_partner"
          >
            R.F.C. del {{ (maritalStatusModel.status.toString().toUpperCase() == 'CONCUBINATO')? 'concubino(a)': 'cónyuge'  }}:
          </label>
          <input tyepe="text" name="input_RFC_partner" id="input_RFC_partner"
            class="uppercase"
            :minlength="validations.rfc.maxlength.$params.max"
            :maxlength="validations.rfc.minlength.$params.min"
            v-model="maritalStatusModel.rfc"
            v-maska="'AAAA######XXX'"
            v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]:  _maritalStatus$.rfc.$error,
                            [view_class_view.input_class.default + view_class_view.input_class.valid]:! _maritalStatus$.rfc.$invalid,
                            [view_class_view.input_class.default ]:  _maritalStatus$.rfc.$invalid && ! _maritalStatus$.rfc.$error  }"
            @blur="_maritalStatus$.rfc.$validate()"/>

          <div :class="view_class_view.div_container_error.container" v-for="error of _maritalStatus$.rfc.$errors" :key="error.$message">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
          </div>
        </div>

          <!-- Regime of goods -->
        <div v-show="displayInputs.dateOfBirth">
          <label :class="view_class_view.div_container.label" for="select_birthdate_partner" >
            Fecha de nacimiento:
          </label>
          <p id="select_birthdate_partner" :class="view_class_view.div_container.p">
            {{ maritalStatusModel.dateOfBirth }}
          </p>
        </div>
    
      <!-- Pathernal name -->
        <div v-show="displayInputs.paternalName">
          <label :class="view_class_view.div_container.label" for="input_last_name_partner" >
            Apellido Paterno:
          </label>
          <input type="text" name="input_last_name_partner" id="input_last_name_partner"
          v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]:  _maritalStatus$.paternalName.$error,
                            [view_class_view.input_class.default + view_class_view.input_class.valid]:! _maritalStatus$.paternalName.$invalid,
                            [view_class_view.input_class.default ]:  _maritalStatus$.paternalName.$invalid && ! _maritalStatus$.paternalName.$error  }"
            v-model="maritalStatusModel.paternalName"
            @blur="_maritalStatus$.paternalName.$validate"
            />

          <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _maritalStatus$.paternalName.$errors" :key="index">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
          </div>
        </div>

      <!-- Mathernal name -->
      <div v-show="displayInputs.maternalName">
        <label :class="view_class_view.div_container.label" for="input_mothers_last_name_partner" >
          Apellido Materno:
        </label>
        <input type="text" name="input_mothers_last_name_partner" id="input_mothers_last_name_partner"
          v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]:  _maritalStatus$.maternalName.$error,
                          [view_class_view.input_class.default + view_class_view.input_class.valid]:! _maritalStatus$.maternalName.$invalid,
                          [view_class_view.input_class.default ]:  _maritalStatus$.maternalName.$invalid && ! _maritalStatus$.maternalName.$error  }"
            v-model="maritalStatusModel.maternalName"
            @blur="_maritalStatus$.maternalName.$validate"
        />

        <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _maritalStatus$.maternalName.$errors" :key="index">
          <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
        </div>

      </div>

      <!-- First Name -->
      <div v-show="displayInputs.firstName">
        <label :class="view_class_view.div_container.label" for="input_first_name_partner">
          Nombre:
        </label>
        <input type="text" name="input_first_name_partner" id="input_first_name_partner" 
        v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]:  _maritalStatus$.firstName.$error,
                          [view_class_view.input_class.default + view_class_view.input_class.valid]:! _maritalStatus$.firstName.$invalid,
                          [view_class_view.input_class.default ]:  _maritalStatus$.firstName.$invalid && ! _maritalStatus$.firstName.$error  }"
          v-model="maritalStatusModel.firstName"
          @blur="_maritalStatus$.firstName.$validate"
          />

        <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _maritalStatus$.firstName.$errors" :key="index">
          <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
        </div>
      </div>
    
        <!-- Second Name -->
        <div v-show="displayInputs.secondName">
        <label :class="view_class_view.div_container.label" for="input_second_name_partner">
          Segundo Nombre:
          </label>
          <input name="input_second_name_partner" id="input_second_name_partner"
          v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]:  _maritalStatus$.secondName.$error,
                          [view_class_view.input_class.default + view_class_view.input_class.valid]:! _maritalStatus$.secondName.$invalid,
                          [view_class_view.input_class.default ]:  _maritalStatus$.secondName.$invalid && ! _maritalStatus$.secondName.$error  }"
            v-model="maritalStatusModel.secondName"
            @blur="_maritalStatus$.secondName.$validate">

          <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _maritalStatus$.secondName.$errors" :key="index">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
          </div>
        </div>

        <!-- Gender -->
        <div v-show="displayInputs.gender">
          <ChooseButton
            ref="RefChooseButtonGender"
            :buttons="buttonsGenders"
            :containerClass="'md:flex'"
            v-on:choose-button="get_value_choose_button_gender($event)"
            label="Género:"
            :buttons_styles="buttons_styles" />
          <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _maritalStatus$.gender.$errors" :key="index">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
          </div>

        </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { ref } from '@vue/reactivity';
import ChooseButton from "./Forms/ChooseButton.vue";
import { watch } from "vue";
import moment from "moment";
export default {
  name:"MaritalStatusComponent",
  components:{
      ChooseButton
  },
  props:{
      validations:{
        type: Object,
        default(){
          return {};
        }
      },
      view_class_view:{
        type: Object,
        default(){
          return {
            input_class:{
              valid:"border-blue-600",
              no_valid:"border-red-600",
              default:"RobotoMedium w-full md:w-80 h-9 text-sm	items-center flex py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
            },
            div_container_error:{
              container:"my-2",
              text_error:"text-red-600 text-sm",
            },
            div_container:{
              container:"grid md:grid-cols-3 grid-cols-1 gap-10 mt-10 ml-8",
              label:"w-full RobotoRegular text-base"
            }
          }
        }
      },
      buttons_styles:{
        type: Object,
        default(){
          return {
            buttonSelected:"",
            activeColorBackground: '#EA7F0B !important',
            inactiveColorBackground: '#FFFFFF !important',
            activeColorText: '#FFFFFF !important',
            inactiveColorText: '#EA7F0B !important',
            activeBorderColor: '#EA7F0B',
            inactiveBorderColor: '#EA7F0B'
          }
        }
      }
  },
  setup(props) {

    const RefChooseButtonRegimeOfGoods = ref(null);
    const RefChooseButtonGender = ref(null);
      
      let maritalStatusModel = ref( { status: "", regimeOfGoods: "", rfc: "", dateOfBirth: "AAAA-MM-DD", paternalName: "", maternalName: "", firstName: "", secondName: "", gender: ""} );

      let displayInputs = ref({
        status: false,
        regimeOfGoods: false,
        rfc: false,
        dateOfBirth: false,
        paternalName: false,
        maternalName: false,
        firstName: false,
        secondName: false,
        gender: false,
      });
      
      let _maritalStatus$ = useVuelidate(props.validations,maritalStatusModel);

      const buttonsRegimeOfGoods = ref([
          { id: "button_man", value: "mancumunados", text: "Mancumunados" },
          { id: "button_sep", value: "separados", text: "Separados" },
      ]);

      const buttonsGenders = ref([
        { id: "button_gender_partner_male", value: "masculino", text: "Hombre" },
        { id: "button_gender_partner_female", value: "femenino", text: "Mujer" },
      ])

      watch( () => maritalStatusModel.value.rfc, (value) => {
        
        if(value.length <_maritalStatus$.value.rfc.minlength.$params.min){
            maritalStatusModel.value.dateOfBirth = "";
            return false;
        }

        const dateOfBirth = get_birth_day_by_rfc(value);
        maritalStatusModel.value.dateOfBirth = moment(dateOfBirth).format("YYYY/MM/DD");
        
        }
      );

      function get_value_choose_button_regime(regimeOfGoods){
        maritalStatusModel.value.regimeOfGoods = regimeOfGoods;
      }

      function get_value_choose_button_gender(gender){
        maritalStatusModel.value.gender = gender;
      }

      function get_birth_day_by_rfc(value) {
        //TODO: cambiar este metodo por servicio get_date_by_rfc
        const m = value.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ );
        let year = parseInt(m[1],10)+1900;
        if( year < 1925 ) year += 100;
          const month = parseInt(m[2], 10);
          const day = parseInt(m[3], 10);
          // console.log("Fecha:", `${year}-${month}-${day}`);
          return `${year}-${month}-${day}`;
      }

      function on_change_civil_status(){

        const isSelected =  maritalStatusModel.value.status == "Casado(a)"  || maritalStatusModel.value.status == "Concubinato";
        // console.log(isSelected)
        if(!isSelected){
          const status = Object.assign(maritalStatusModel.value.status).toString();
          displayInputs.value = { status: false, regimeOfGoods: false, rfc: false, dateOfBirth: false, paternalName: false, maternalName: false, firstName: false, secondName: false, gender: false };
          maritalStatusModel.value = { status: status, regimeOfGoods: "", rfc: "", dateOfBirth: "AAAA-MM-DD", paternalName: "", maternalName: "", firstName: "", secondName: "", gender: ""}
          this._maritalStatus$.$reset()
          return
        }

        displayInputs.value = {
          status: true, regimeOfGoods: true, rfc: true, dateOfBirth: true, paternalName: true, maternalName: true, firstName: true, secondName: true, gender: true,
        }

      }

      function execute_validation() {
        this._maritalStatus$.$validate();
        if(this._maritalStatus$.$error){
          return false;
        }
        return maritalStatusModel.value;
      }

      function reset_validation()
      {
        this._maritalStatus$.$reset()
      }

      return {
          maritalStatusModel,
          _maritalStatus$,
          buttonsRegimeOfGoods,
          buttonsGenders,
          on_change_civil_status,
          displayInputs,
          get_value_choose_button_gender,
          get_value_choose_button_regime,
          execute_validation,
          RefChooseButtonGender,
          RefChooseButtonRegimeOfGoods,
          get_birth_day_by_rfc,
          reset_validation
      }
      
  },
}
</script>